import React from 'react';
import './Rightplasti.css';
import plastic from '../../../imgs/plasticpa.webp';

const Rightplasti = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">How To Choosing The Right Plastic Pallet Injection Molding Machine?</h2>
                                             <p className="Cavity-date">Dec. 13, 2022</p>               

                <div className="Material">
                    <img src={plastic} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Material-text">There are increasing plastic molders choosing 
                    two-platen injection molding machines, why? The major reason is that the special two-platen injection molding machine 
                    highlights meet various production demands of the plastic injection molding parts.</p>

            </div>
        </div>
    );
};
export default Rightplasti;
